// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { AppRoutes } from 'utilities/router/AppRoutes';
import { useAuthContext } from '@tls/auth';
import Icon404 from 'components/treactui-template/icons/Icon404';
import { Background, Details, Title } from 'components/common/Background';
import IconHome from 'components/treactui-template/icons/IconHome';
import { Button } from '@tls/treact-ui';

export default function NotFound() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const { appBaseUrl } = useAuthContext();
  const goHome = useCallback(() => navigate(AppRoutes.Projects), [navigate]);

  return (
    <Background $appBaseUrl={appBaseUrl ?? ''}>
      <div className='icon'>
        <Icon404 />
      </div>
      <Details className='text'>
        <Title>{t('notFound.title')}</Title>
        <div className='font-size_m details'>{t('notFound.details')}</div>

        <Button
          icon={<IconHome />}
          className='margin-top'
          label={t('error.home')}
          onClick={goHome}
          variant='secondary'
          data-testid='app-not-found-home-button'
        />
      </Details>
    </Background>
  );
}
